import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MetadatiService } from 'src/app/amministrazione/components/metadati/metadati/service/metadati.service';
import { FascicoloMap } from 'src/app/common/models/fascicolo-map';
import { FascicoloLight } from 'src/app/common/models/fascicolo/fascicolo-light';
import { Metadata, MetadataExt } from 'src/app/common/models/metadati/metadata';
import { OperationsService } from 'src/app/core/services/operations.service';

@Component({
  selector: 'app-fascicolo-metadata-form',
  templateUrl: './fascicolo-metadata-form.component.html',
  styleUrls: ['./fascicolo-metadata-form.component.css']
})
export class FascicoloMetadataFormComponent implements OnInit{

  @Input() tipoFascicolo: string;
  @Input() fascicolo: FascicoloLight;
  @Output() metadataListChange: EventEmitter<MetadataExt[]> = new EventEmitter();
  @Output() formChange: EventEmitter<boolean> = new EventEmitter();
  metadata:MetadataExt[] = [];

  constructor(
    private metadatiService: MetadatiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.tipoFascicolo){
      if (this.tipoFascicolo && this.tipoFascicolo !== null && this.tipoFascicolo !== undefined) {
        this.metadatiService.findAllByDossierType(this.tipoFascicolo).subscribe(next => {
          if(next.length === 0){
            this.formChange.emit(true);
          }
          this.metadata = next.sort((a, b) => a.order - b.order).map(obj => obj.item as MetadataExt);
        });
      }
    }

    if(changes.fascicolo){
      this.metadatiService.findAllByDossierType(this.fascicolo.tipoFascicolo.id).subscribe(next => {
        this.metadata = [];
        let metadataFascicolo = []
        if(this.fascicolo.metadata && this.fascicolo.metadata.length != 0){
          metadataFascicolo = this.fascicolo.metadata.sort((a, b) => a.order - b.order).map(obj => obj);
          this.metadata.push(...metadataFascicolo);
        }
        let metadataAssociated = []
        let nuoviElementi = []
        if(next && next.length != 0){
          metadataAssociated = next.sort((a, b) => a.order - b.order).map(obj => obj.item as MetadataExt);
          nuoviElementi = metadataAssociated.filter(item => !metadataFascicolo
                                            .some(itemAssociated => itemAssociated.id === item.id))
                                            .sort((a, b) => a.order - b.order);
          if(nuoviElementi.length != 0){
          this.metadata.push(...nuoviElementi);
          }
        }
        if(this.metadata.length == 0){
          this.formChange.emit(true);
        }
      });

    }
  }

  ngOnInit(): void {
  }

  retrieveMetadataExt(metadata: MetadataExt[]){
    this.metadataListChange.emit(metadata.filter(s => s.value != null && s.value != ""));
  }

  retrieveFormValid(value: FormGroup){
    this.formChange.emit(value.valid);
  }

}
